module.exports = __webpack_public_path__ + "img/1168126876.3154cb8e.jpg";